import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectDataSource } from '../libs/ax-select/select-data-source';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';
import { Cid10Dto } from '../dtos/doencas/cid10-dto';

@Injectable({
  providedIn: 'root'
})
export class Cid10Service {

  constructor(private http: HttpClient, private url: UrlService) { }

  dsCids10(): SelectDataSource {
    return new SelectDataSource({
      url: this.url.url('cids10/selecao')
    });
  }

  listarCids10(cid10?: string): Observable<Cid10Dto[]> {
    let params = new HttpParams();

    if (cid10) {
      params = params.set('cid10', cid10);
    }

    return this.http.get<Cid10Dto[]>(this.url.url('cids10'), { params });
  }
  
}
